import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px CardenioBold',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });

        this.load.on('complete', function () {
            // this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() {

        this.load.audio('click', 'assets/audios/clic.mp3');
        this.load.audio('pop', 'assets/audios/pop.mp3');
        this.load.audio('whoosh', 'assets/audios/whoosh.mp3');
        this.load.audio('win', 'assets/audios/win.mp3');
        this.load.audio('lose', 'assets/audios/lose.mp3');
        this.load.audio('interference', 'assets/audios/interference.mp3');
        this.load.audio('descente', 'assets/audios/descente.mp3');
        this.load.audio('montee', 'assets/audios/montee.mp3');

        // this.load.audio('minimalActivite', 'assets/audios/minimal-activite.mp3 ');
        this.load.audio('minimal', 'assets/audios/minimal.mp3');



        this.load.video('videoIntro', 'assets/videos/video-intro.mp4', 'loadeddata', false, true);
        this.load.video('videoA1', 'assets/videos/video-cerveau.mp4', 'loadeddata', false, true);
        this.load.video('videoB1', 'assets/videos/video-parcours-medicament.mp4', 'loadeddata', false, true);
        this.load.image('videoA1Blocker', 'assets/videos/video-cerveau-blocker.png');
        this.load.image('videoIntroBlocker', 'assets/videos/video-intro-blocker.png');
        this.load.image('videoB1Blocker', 'assets/videos/video-parcours-medicament-blocker.png');







        this.load.image('mainLogo', 'assets/images/main-logo.png');
        this.load.image('volume', 'assets/images/volume.png');

        this.load.image('clapLogo', 'assets/images/credits/clap.png');
        this.load.image('fondationFondamentalLogo', 'assets/images/credits/fondation-fondamental.png');
        this.load.image('klesiaLogo', 'assets/images/credits/klesia.png');
        this.load.image('leVinatierLogo', 'assets/images/credits/le-vinatier.png');
        this.load.image('sydoLogo', 'assets/images/credits/sydo.png');
        this.load.image('unafamLogo', 'assets/images/credits/unafam.png');


        this.load.image('videoPlay', 'assets/images/video-play.png');
        this.load.image('bouton', 'assets/images/bouton.png');
        this.load.image('home', 'assets/images/home.png');

        // MENU
        this.load.image('A1Cadre', 'assets/images/menu/A1-cadre.png');
        this.load.image('A1Illu', 'assets/images/menu/A1-illu.png');
        this.load.image('A2Cadre', 'assets/images/menu/A2-cadre.png');
        this.load.image('A2Illu', 'assets/images/menu/A2-illu.png');
        this.load.image('A3Cadre', 'assets/images/menu/A3-cadre.png');
        this.load.image('A3Illu', 'assets/images/menu/A3-illu.png');
        this.load.image('B1Cadre', 'assets/images/menu/B1-cadre.png');
        this.load.image('B1Illu', 'assets/images/menu/B1-illu.png');
        this.load.image('B2Cadre', 'assets/images/menu/B2-cadre.png');
        this.load.image('B2Illu', 'assets/images/menu/B2-illu.png');
        this.load.image('B3Cadre', 'assets/images/menu/B3-cadre.png');
        this.load.image('B3Illu', 'assets/images/menu/B3-illu.png');
        this.load.image('RenfoIllu', 'assets/images/menu/renfo-illu.png');

        // B2
        this.load.image('b2Screen1', 'assets/images/B2/screen-1-illu.png')
        this.load.image('b2Screen2B', 'assets/images/B2/screen-2-illu-2.png');
        this.load.image('b2Screen2A', 'assets/images/B2/screen-2-illu-1.png');
        this.load.image('b2Screen3', 'assets/images/B2/screen-3-illu.png')
        this.load.image('b2Screen4', 'assets/images/B2/screen-4-illu.png')
        this.load.image('b2Screen5', 'assets/images/B2/screen-5-illu.png')
        this.load.image('b2Screen6', 'assets/images/B2/screen-6-illu.png')
        this.load.image('b2Screen7', 'assets/images/B2/screen-7-illu.png')
        this.load.image('b2Screen8', 'assets/images/B2/screen-8-illu.png')
        this.load.image('b2Screen9', 'assets/images/B2/screen-9-illu.png')
        this.load.image('b2Screen10', 'assets/images/B2/screen-10-illu.png')
        this.load.image('b2Screen11', 'assets/images/B2/screen-11-illu.png')
        this.load.image('accoladeA', 'assets/images/B2/accolade-a.png')
        this.load.image('accoladeB', 'assets/images/B2/accolade-b.png')
        this.load.image('accoladeC', 'assets/images/B2/accolade-c.png')


        this.load.image('illuB3Intro1', 'assets/images/B3/traitements.png')
        this.load.image('illuB3Intro2', 'assets/images/B3/plus.png')
        this.load.image('illuB3Intro3', 'assets/images/B3/interrogation.png')


        this.load.image('b3MonsieurLunettes', 'assets/images/B3/monsieur_lunettes.png')
        this.load.image('b3MonsieurGratteLaTete', 'assets/images/B3/monsieur_gratte_la_tete.png')
        this.load.image('b3MonsieurEcharpe', 'assets/images/B3/monsieur_echarpe.png')
        this.load.image('b3MonsieurCasque', 'assets/images/B3/monsieur_casque.png')
        this.load.image('b3MadameVielle', 'assets/images/B3/madame_vielle.png')
        this.load.image('b3MadameTresse', 'assets/images/B3/madame_tresse.png')
        this.load.image('b3MadameCasquette', 'assets/images/B3/madame_casquette.png')
        this.load.image('bulle', 'assets/images/B3/bulle.png')

        this.load.image('goodB3', 'assets/images/B3/good-b3.png')
        this.load.image('wrongB3', 'assets/images/B3/wrong-b3.png')

        this.load.image('arrowLeftB3', 'assets/images/B3/arrow-left.png')
        this.load.image('arrowRightB3', 'assets/images/B3/arrow-right.png')


        this.load.image('b3EndRythmeRegulier', 'assets/images/B3/end-screen/rythme-regulier.png')
        this.load.image('b3EndAlimentationEquilibree', 'assets/images/B3/end-screen/alimentation-equilibree.png')
        this.load.image('b3EndActivitePhysique', 'assets/images/B3/end-screen/activite-physique.png')

        this.load.image('b3EndMaintenirLesLiens', 'assets/images/B3/end-screen/maintenir-les-liens.png')
        this.load.image('b3EndSAppuyerSurLesProches', 'assets/images/B3/end-screen/s-appuyer-sur-les-proches.png')
        this.load.image('b3EndSentimentDAppartenance', 'assets/images/B3/end-screen/sentiment-d-appartenance.png')

        this.load.image('b3EndLoisirsCreativite', 'assets/images/B3/end-screen/loisirs-creativite.png')
        this.load.image('b3EndActiviteProfessionnelles', 'assets/images/B3/end-screen/activite-professionnelles.png')

        this.load.image('b3EndArrow', 'assets/images/B3/end-screen/end-arrow.png')


        // A2
        this.load.image('A2-1', 'assets/images/A2/introImg.png');
        this.load.image('feedback2', 'assets/images/A2/feedback-2.png');
        this.load.image('feedback1', 'assets/images/A2/feedback-1.png');
        this.load.image('screenA1', 'assets/images/A2/screen-A1.png');
        this.load.image('screenA2', 'assets/images/A2/screen-A2.png');
        this.load.image('screenA3', 'assets/images/A2/screen-A3.png');
        this.load.image('screenA4', 'assets/images/A2/screen-A4.png');
        this.load.image('screenB1', 'assets/images/A2/screen-B1.png');
        this.load.image('screenB2', 'assets/images/A2/screen-B2.png');

        this.load.image('screenC1', 'assets/images/A2/screen-C1.png');
        this.load.image('screenC2', 'assets/images/A2/screen-C2.png');
        this.load.image('screenC3', 'assets/images/A2/screen-C3.png');
        this.load.image('screenC4', 'assets/images/A2/screen-C4.png');
        this.load.image('screenC5', 'assets/images/A2/screen-C5.png');
        this.load.image('screenC6', 'assets/images/A2/screen-C6.png');
        this.load.image('screenC7', 'assets/images/A2/screen-C7.png');
        this.load.image('screenC8', 'assets/images/A2/screen-C8.png');
        this.load.image('screenC10', 'assets/images/A2/screen-C10.png');



        this.load.image('sliderBar', 'assets/images/A2/slider-bar.png');
        this.load.image('slider0', 'assets/images/A2/slider-0.png');
        this.load.image('slider1', 'assets/images/A2/slider-1.png');
        this.load.image('slider2', 'assets/images/A2/slider-2.png');
        this.load.image('slider3', 'assets/images/A2/slider-3.png');
        this.load.image('slider4', 'assets/images/A2/slider-4.png');
        this.load.image('slider5', 'assets/images/A2/slider-5.png');
        this.load.image('slider6', 'assets/images/A2/slider-6.png');
        this.load.image('slider7', 'assets/images/A2/slider-7.png');
        this.load.image('slider8', 'assets/images/A2/slider-8.png');
        this.load.image('slider9', 'assets/images/A2/slider-9.png');

        this.load.image('facteursStress', 'assets/images/A2/facteurs-stress.png');
        this.load.image('check', 'assets/images/A2/check.png');
        this.load.image('facteursVulnerabilite', 'assets/images/A2/facteurs-vulnerabilite.png');
        this.load.image('croix', 'assets/images/A2/croix.png');


        this.load.image('concluBulleAmour', 'assets/images/conclusion/bulle-amour.png');
        this.load.image('concluBulleMain', 'assets/images/conclusion/bulle-main.png');
        this.load.image('concluBulleVoyage', 'assets/images/conclusion/bulle-voyage.png');
        this.load.image('concluPersoRando', 'assets/images/conclusion/perso-rando.png');

        this.load.image('concluChemin', 'assets/images/conclusion/chemin.png');
        this.load.image('concluSmallPersoRando1', 'assets/images/conclusion/small-perso-rando-1.png');
        this.load.image('concluSmallPersoRando2', 'assets/images/conclusion/small-perso-rando-2.png');
        this.load.image('concluSmallPersoRando3', 'assets/images/conclusion/small-perso-rando-3.png');

        this.load.image('concluSoignant', 'assets/images/conclusion/soignant.png');
        this.load.image('concluFille', 'assets/images/conclusion/fille.png');
        this.load.image('concluGarcon', 'assets/images/conclusion/garcon.png');
        this.load.image('concluPersoRandoMuscles', 'assets/images/conclusion/perso-rando-muscles.png');

        this.load.image('concluEspoir', 'assets/images/conclusion/espoir.png');
        this.load.image('concluSeReconstruire', 'assets/images/conclusion/se-reconstruire.png');
        this.load.image('concluDonner', 'assets/images/conclusion/donner.png');
        this.load.image('concluSeResponsabiliser', 'assets/images/conclusion/se-responsabiliser.png');

        this.load.image('concluPersoRandoEnPied', 'assets/images/conclusion/perso-rando-en-pied.png');

        this.load.image('concluEndFull', 'assets/images/conclusion/end-full.png');


    }
}